import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';

export default function LogPointGamificationDetail({ data }) {
  return (
    <div>
      <h2 className="pt-5 pl-5 font-semibold text-purple-800">Point Detail</h2>
      <div className="px-5 py-2 grid grid-cols-2">
        <div className="py-3 text-sm font-semibold border-b">Customer Name</div>
        <div className="py-3 text-sm border-b">
          {data.customer.customer_name !== null
            ? data.customer.customer_name?.join(', ')
            : ''}
        </div>
        <div className="py-3 text-sm font-semibold border-b">Tier</div>
        <div className="py-3 text-sm border-b">
          {data.customer.tier.tier_name}
        </div>
        <div className="py-3 text-sm font-semibold border-b">Point</div>
        <div className="py-3 text-sm border-b">{`${data.point.point} ${
          data.point.is_bonus_point ? '(Bonus Point)' : ''
        }`}</div>
        <div className="py-3 text-sm font-semibold border-b">Created At</div>
        <div className="py-3 text-sm border-b">
          {moment(data.created_at).format('DD MMMM YYYY HH:mm')}
        </div>
      </div>
    </div>
  );
}

LogPointGamificationDetail.propTypes = {
  data: PropTypes.object.isRequired
};
